import { Model } from '@vuex-orm/core';
import { timestamps } from '@app2/utils/model-fields';
import File from '@app2/models/File';
import moment from '@app2/utils/moment';
import Connection from '@app2/models/Connection';
import FolderPlaylist from "@app2/models/FolderPlaylist";
import Playlist from "@app2/models/Playlist";

export default class Folder extends Model {
  static entity = 'App\\Folder';

  static apiConfig = {
    baseURL: "/api/folders/",
    actions: {
      fetch: {
        url: '/',
        dataKey: 'data'
      },
      attachFiles(folder, files) {
        return this.put(`${folder.hash}/bulk-move-file`, { files }, {save: false})
      },
      detachFiles(folder, files) {
        return this.put(`${folder.hash}/bulk-move-file`, { files }, {save: false})
      },
    }
  };

  static fields() {
    return {
      id: this.attr(null),
      hash: this.attr(null),
      connection_type: this.attr(null),
      connection_id: this.attr(null),
      // connection: this.belongsTo(Connection, 'connection_id'),
      connection: this.attr(null),
      source_id: this.attr(null),
      title: this.attr(null),
      highlight: this.attr(null),
      is_auto_sync: this.attr(null),
      is_default: this.attr(null),
      is_remote_sync_failed: this.attr(null),
      meta: this.attr(null),
      created_at_local: this.attr(null),
      files: this.hasMany(File, 'folder_id'),
      files_count: this.attr(null),
      file_thumbnails: this.attr(null),
      files_processed_count: this.attr(null),
      files_pdf_img_count: this.attr(null),
      files_documents_count: this.attr(null),
      page: this.attr(null),
      playlists: this.belongsToMany(Playlist, FolderPlaylist, 'folder_id', 'playlist_id'),
      folder_playlists: this.hasMany(FolderPlaylist, 'folder_id', 'id'),
      ...timestamps,
    };
  }

  static beforeCreate(model) {
    Folder.updateTime(model);
  }

  static beforeUpdate(model) {
    Folder.updateTime(model);
  }

  static updateTime(model) {
    if (model.created_at_local || !model.created_at) return;
    model.created_at_local = moment(model.created_at).format("MMMM D, YYYY @ hh:mm");
  }

  get icon() {
    return Folder.getIcon();
  }

  static getIcon() {
    return `<svg width="24" viewBox="0 0 24 24" class="icon-regular">
              <use xlink:href="#icon-folder"></use>
            </svg>`
  }

  get image() {
    return this.icon;
  }

  isInPlaylist(playlistId) {
    if (!this.folder_playlists) return false;
    return this.folder_playlists.map(p => p.playlist_id).includes(playlistId);
  }

  get lowerTitle() {
    return (this.title) ? this.title.toLowerCase() : '';
  }

  get processedCount() {
    return this.files_processed_count + this.files_documents_count;
  }
}
